import { createContext, useContext, useState, ReactNode } from "react";

interface OrdersPageContextType {
    name: string;
    setName: (value: string) => void;
    lastname: string;
    setLastname: (value: string) => void;
    orderNumber: string;
    setOrderNumber: (value: string) => void;
}

const OrdersPageContext = createContext<OrdersPageContextType | undefined>(undefined);

export const OrdersPageProvider = ({ children }: { children: ReactNode }) => {
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [orderNumber, setOrderNumber] = useState("");

    return (
        <OrdersPageContext.Provider value={{ name, setName, lastname, setLastname, orderNumber, setOrderNumber }}>
            {children}
        </OrdersPageContext.Provider>
    );
};

export const useOrdersPageContext = () => {
    const context = useContext(OrdersPageContext);
    if (!context) {
        throw new Error("useOrdersPageContext must be used within an OrdersPageProvider");
    }
    return context;
};
